module.exports = __webpack_public_path__ + "img/heima.b5a855ee.png";